import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BluetoothPrinterPage } from './bluetooth-printer';

@NgModule({
  declarations: [
    BluetoothPrinterPage,
  ],
  imports: [
    IonicPageModule.forChild(BluetoothPrinterPage),
  ],
})
export class BluetoothPrinterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/bluetooth-printer/bluetooth-printer.module.ts